import { render, staticRenderFns } from "./QuickInvoiceItems.vue?vue&type=template&id=48974b6b&scoped=true"
import script from "./QuickInvoiceItems.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceItems.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoiceItems.vue?vue&type=style&index=0&id=48974b6b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48974b6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48974b6b')) {
      api.createRecord('48974b6b', component.options)
    } else {
      api.reload('48974b6b', component.options)
    }
    module.hot.accept("./QuickInvoiceItems.vue?vue&type=template&id=48974b6b&scoped=true", function () {
      api.rerender('48974b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickinvoice/QuickInvoiceItems.vue"
export default component.exports